import { startCase, find, sortBy } from "lodash";
import { initAssetGraphColors } from "./chartColors";

export const privateHoldings = ["privateSecurities"];

export const currencies = [
  {
    value: "AED",
    label: "AED (د.إ) UAE dirham",
  },
  {
    value: "AUD",
    label: "AUD (A$) Australian dollar",
  },
  {
    value: "BRL",
    label: "BRL (R$) Brazilian reais",
  },
  {
    value: "BTC",
    label: "BTC (₿) Bitcoin",
  },
  {
    value: "CAD",
    label: "CAD (C$) Canadian dollar",
  },
  {
    value: "CHF",
    label: "CHF (₣) Swiss franc",
  },
  {
    value: "CNY",
    label: "CNY (¥) Renminbi",
  },
  {
    value: "EUR",
    label: "EUR (€) Euro",
  },
  {
    value: "GBP",
    label: "GBP (£) Pound sterling",
  },
  {
    value: "HKD",
    label: "HKD Hong Kong dollar",
  },
  {
    value: "IDR",
    label: "IDR (Rp) Indonesian rupiah",
  },
  {
    value: "INR",
    label: "INR (₹) Indian rupee",
  },
  {
    value: "JPY",
    label: "JPY (¥) Yen",
  },
  {
    value: "KRW",
    label: "KRW (₩) South Korean won",
  },
  {
    value: "RUB",
    label: "RUB (₽) Russian ruble",
  },
  {
    value: "SEK",
    label: "SEK (kr) Swedish krona",
  },
  {
    value: "SGD",
    label: "SGD (S$) Singapore dollar",
  },

  {
    value: "USD",
    label: "USD ($) US dollar",
  },
  {
    value: "ZAR",
    label: "ZAR (R) Rand",
  },
  {
    value: "SAR",
    label: "SAR (يال) Saudi Arabian riyal",
  },
  {
    value: "NGN",
    label: "NGN (₦) Nigerian naira",
  },
  {
    value: "DKK",
    label: "DKK (kr.) Danish krone",
  },
  {
    value: "NOK",
    label: "NOK (kr) Norwegian krone",
  },
  {
    value: "MXN",
    label: "MXN ($) Mexican peso",
  },
  {
    value: "THB",
    label: "THB (฿) Thai baht",
  },
  {
    value: "TRY",
    label: "TRY (₺) Turkish lira",
  },
  {
    value: "NZD",
    label: "NZD ($) New Zealand dollar",
  },
  {
    value: "MYR",
    label: "MYR (RM) Malaysian ringgit",
  },
  {
    value: "QAR",
    label: "QAR (QR) Qatari riyal",
  },
  {
    value: "PKR",
    label: "PKR (₨) Pakistani rupee",
  },
  {
    value: "EGP",
    label: "EGP (E£) Egyptian pound",
  },
  {
    value: "VND",
    label: "VND (₫) Vietnamese dong",
  },
  {
    value: "PHP",
    label: "PHP (₱) Philippine peso",
  },
  {
    value: "ILS",
    label: "ILS (₪) Israeli sheqel",
  },
  {
    value: "TWD",
    label: "TWD (NT$) New Taiwan dollar",
  },
  {
    value: "PLN",
    label: "PLN (zł) Polish złoty",
  },
  {
    value: "ARS",
    label: "ARS ($) Argentine peso",
  },
  {
    value: "RON",
    label: "RON (lei) Romanian leu",
  },
  {
    value: "CZK",
    label: "CZK (Kč) Czech koruna",
  },
  {
    value: "KZT",
    label: "KZT (₸) Kazakhstani tenge",
  },
  {
    value: "HUF",
    label: "HUF (Ft) Hungarian forint",
  },
  {
    value: "KWD",
    label: "KWD (د.ك) Kuwaiti finar",
  },
  {
    value: "MAD",
    label: "MAD (د. م) Moroccan dirham",
  },
  {
    value: "KES",
    label: "(KSh) Kenyan shilling",
  },
  {
    value: "TZS",
    label: "(TSh) Tanzanian shilling",
  },
  {
    value: "CLP",
    label: "CLP ($) Chilean peso",
  },
  {
    value: "COP",
    label: "COP ($) Colombian peso",
  },
  {
    value: "ARSB",
    label: "ARSB ($) Argentine peso blue",
  },
  {
    value: "IRR",
    label: "IRR (﷼) Iranian rial",
  },
  {
    value: "CRC",
    label: "CRC (₡) Costa Rican colón",
  },
  {
    value: "AMD",
    label: "AMD (Դ) Armenian dram",
  },
  {
    value: "BDT",
    label: "BDT (৳) Bangladeshi taka",
  },
];

export const transactionTypes = [
  {
    value: "DEPOSIT",
    label: "DEPOSIT",
  },
  {
    value: "WITHDRAWAL",
    label: "WITHDRAWAL",
  },
  {
    value: "INCOME",
    label: "INCOME",
  },

  {
    value: "EXPENSE",
    label: "EXPENSE",
  },
];

export const piTransactionTypes = [
  {
    value: "BUY",
    label: "BUY",
  },
  {
    value: "SELL",
    label: "SELL",
  },
  {
    value: "INCOME",
    label: "INCOME",
  },
  {
    value: "EXPENSE",
    label: "EXPENSE",
  },
];

export const seriesInputs = [
  {
    value: "PRE_SEED",
    label: "Pre-Seed",
  },
  {
    value: "SEED",
    label: "Seed",
  },
  {
    value: "A",
    label: "A",
  },
  {
    value: "B",
    label: "B",
  },
  {
    value: "C",
    label: "C",
  },
  {
    value: "D",
    label: "D",
  },
  {
    value: "E",
    label: "E",
  },
];

let aClass = [
  {
    value: "cash",
    label: "Cash",
    type: "cash",
  },
  {
    value: "realEstate",
    label: "Real Estate",
    type: "investment",
  },
  {
    value: "publicFundsSecurities",
    label: "Public Funds & Securities",
    type: "investment",
  },
  {
    value: "privateFunds",
    label: "Private Funds",
    type: "investment",
  },
  {
    value: "pensionFunds",
    label: "Pension Funds",
    type: "investment",
  },
  {
    value: "privateSecurities",
    label: "Private Securities",
    type: "investment",
  },
  {
    value: "preciousMetals",
    label: "Precious Metals",
    type: "investment",
  },
  {
    // TODO: need update when release https://github.com/exiriofinance/backend/issues/569
    value: "jewelleryNWatches",
    label: "Luxury Assets",
    type: "investment",
  },
  {
    value: "cryptocurrencies",
    label: "Cryptocurrencies",
    type: "investment",
  },
  {
    value: "other",
    label: "Other",
    type: "investment",
  },
  {
    value: "loans",
    label: "Loans",
    type: "loan",
  },
];

aClass = sortBy(aClass, "value");

// Init graph colors
aClass.forEach(initAssetGraphColors);

export const assetClasses = aClass;

export const securityTypes = [
  {
    value: "Equity",
    label: "Equity",
  },

  {
    value: "Commodity",
    label: "Commodity",
  },
  {
    value: "Crypto",
    label: "Crypto currencies",
  },
  {
    value: "Cash",
    label: "Cash",
  },
  {
    value: "ETF",
    label: "Etf",
  },
  {
    value: "Bond",
    label: "Bond",
  },
  {
    value: "Derivative",
    label: "Derivative",
  },
  {
    value: "Fund",
    label: "Fund",
  },
];

export const symbolSource = [
  {
    value: "YAHOO-FINANCE",
    label: "YAHOO-FINANCE",
  },

  {
    value: "EOD",
    label: "EOD",
  },
  {
    value: "MMF",
    label: "MMF",
  },
];

export const assetTypes = [
  {
    class: "cash",
    items: [
      {
        value: "bankAccounts",
        label: "Bank Accounts",
        type: "Basic",
      },

      {
        value: "cash",
        label: "Cash",
        type: "Basic",
      },
      {
        value: "otherAccounts",
        label: "Other Accounts",
        type: "Basic",
      },
    ],
  },
  {
    class: "realEstate",
    items: [
      {
        value: "residential",
        label: "Residential",
        type: "Basic",
      },
      {
        value: "commercial",
        label: "Commercial",
        type: "Basic",
      },
      {
        value: "land",
        label: "Land",
        type: "Basic",
      },
      {
        value: "other",
        label: "Other",
        type: "Basic",
      },
    ],
  },
  {
    class: "publicFundsSecurities",
    items: [
      {
        value: "brokerAccounts",
        label: "Broker Accounts (automatic updates not yet available)",
        type: "Basic",
      },
      {
        value: "otherInvestments",
        label: "Other Investment Products",
        type: "Advanced",
      },
      {
        value: "securitiesPortfolios",
        label: "Securities Portfolios (automatic daily price updates)",
        type: "Advanced",
      },
    ],
  },

  {
    class: "privateFunds",
    items: [
      {
        value: "hedgeFunds",
        label: "Hedge Funds",
        type: "Basic",
      },
      {
        value: "privateEquityFunds",
        label: "Private Equity Funds",
        type: "Basic",
      },
      {
        value: "ventureCapitalFunds",
        label: "Venture Capital Funds",
        type: "Basic",
      },
    ],
  },
  {
    class: "pensionFunds",
    items: [
      {
        value: "pensionFunds",
        label: "Pension Funds",
        type: "Basic",
      },
    ],
  },

  {
    class: "privateSecurities",
    items: [
      {
        value: "privateCompanyLoans",
        label: "Private Company Loans",
        type: "Basic",
      },
      {
        value: "privateCompanyShares",
        label: "Private Company Shares",
        type: "Basic",
      },
    ],
  },
  {
    class: "preciousMetals",
    items: [
      {
        value: "preciousMetalsBaskets",
        label: "Precious Metal Baskets",
        type: "Advanced",
      },
    ],
  },
  {
    class: "jewelleryNWatches",
    items: [
      {
        value: "jewelleryNWatches",
        label: "Jewellery & Watches",
        type: "Basic",
      },
    ],
  },
  {
    class: "cryptocurrencies",
    items: [
      {
        value: "nonCustodialWallets",
        label: "Non-Custodial Wallet (automatic daily price updates)",
        type: "Advanced",
      },
      {
        value: "custodialWallets",
        label:
          "Exchange/Custodial Wallet (automatic updates not yet available)",
        type: "Basic",
      },
    ],
  },
  {
    class: "other",
    items: [
      {
        value: "otherInvestments",
        label: "Other Investments",
        type: "Basic",
      },
    ],
  },
  {
    class: "loan",
    items: [
      {
        value: "loans",
        label: "Loans",
        type: "Basic",
      },
    ],
  },
];

export const realEstateInvTypes = [
  {
    assetType: "residential",
    items: [
      {
        value: "Primary residence", //default
        label: "Primary residence",
      },
      {
        value: "Holiday home",
        label: "Holiday home",
      },
      {
        value: "Rental",
        label: "Rental",
      },
    ],
  },
  {
    assetType: "commercial",
    items: [
      {
        value: "Business Use",
        label: "Business Use",
      },
      {
        value: "Rental",
        label: "Rental",
      },
    ],
  },
  {
    assetType: "land",
    items: [
      {
        value: "Production",
        label: "Production",
      },
      {
        value: "Rental",
        label: "Rental",
      },
      {
        value: "Landbank",
        label: "Landbank",
      },
    ],
  },
  {
    assetType: "other", //no dropdown menu
    items: [
      {
        value: "Other",
        label: "Other",
      },
    ],
  },
];

export const manuplateClassName = (aType) => {
  let findVal = find(assetClasses, (val) => {
    return val.value == aType;
  });
  if (findVal) {
    return findVal.label;
  } else {
    return startCase(aType);
  }
};
export const getClassBaseColor = (aType) => {
  let findVal = find(assetClasses, (val) => {
    return val.value == aType;
  });
  // console.log("findVal",findVal)
  if (findVal) {
    return [findVal.baseColor];
  } else {
    return ["#2E93fA"];
  }
};

export const manuplateAssetName = ({ asset_class, asset_type }) => {
  // console.log({asset_class,asset_type});

  let findVal = find(assetTypes, (val) => {
    return val.class == asset_class;
  });
  if (findVal) {
    let findAss = find(findVal.items, (vv) => {
      return vv.value == asset_type;
    });
    if (findAss) {
      return findAss.label;
    } else {
      return startCase(asset_type);
    }
  } else {
    return startCase(asset_type);
  }
};

export const YesNoInputs = [
  {
    value: "false",
    label: "No",
  },
  {
    value: "true",
    label: "Yes",
  },
];
